export default {
  // 客服信息
  kfInfo: {},

  // 是否弹出关闭弹窗
  showClose: false,
  // 是否弹出注册用户活动图
  showUserGift: false,
  // 当前播放音频
  currAudio: null,
  // 上次登录类型 code wx pwd
  prevLoginType: '',
  // 当前首页选中tab
  currTab: 'home',
  // 旧版接口token
  oldToken: '',
  // 新版接口token
  newApiToken: '',
  // 用户详情
  userInfo: '',
  // 用户选择年级
  currGrade: {id: 8, name: "小学一年级", short_name: "一年级", pid: "2"},
  // 全部年级
  allGrades: null,
  // 是否有显示购买弹窗
  isShowPayPopup: false,
	//全部tab页
	allTabsList:[],
  // 微信扫码state
  qrState: '',
  // 搜索记录
  searchHistory:{},
	//刷新搜索记录
	refreshHistory:false,
  // 当前页面编号
  currPageCode: '',
	//当前用户年级会员产品信息
	currUserVip:{},
  // 自定义页面编号列表
  pageCode: {
    // 学龄前
    1: {
      home: 'tuijian_web_xq_v1.0.0', // 首页推荐
      initiate: 'zaojiao_web_xq_v1.0.0', // 启蒙早教
      less: 'shaoer_web_xq_v1.0.0', // 少儿
      knowledge: 'baike_web_xq_v1.0.0', // 百科知识
      boutique: 'jingpin_web_1nianji_v1.0.0', // 精品专区
      sound: 'yousheng_web_1nianji_v1.0.0', // 有声频道
      parent: 'jiazhang_web_1nianji_v1.0.0' // 家长育儿
    },
    // 五四制/七年级/八年级/九年级
    3: {
      home: 'tuijian_web_chuzhong_v1.0.0', // 首页推荐
      boutique: 'jingpin_web_zhongxue_v1.0.0', // 精品专区
      parent: 'jiazhang_web_zhongxue_v1.0.0', // 家长专区
      sound: 'yousheng_web_zhongxue_v1.0.0', // 有声频道
      special: 'zhuanti_web_chuzhong_v1.0.0', // 专题课堂
      // tb: 'tongbuke_web_chuzhong_v1.0.0', // 同步
      tb: {
        14: 'tongbuke_web_chuzhong6nj_v1.0.0', // 五四制同步课程
        15: 'tongbuke_web_chuzhong7nianji_v1.0.0', // 七年级同步课程
        16: 'tongbuke_web_chuzhong8nj_v1.0.0', // 八年级同步课程
        17: 'tongbuke_web_chuzhong9nj_v1.0.0', // 九年级同步课程
      }
    },
    // 高一/高二/高三
    4: {
      home: 'tuijian_web_gaozhong_v1.0.0',
      boutique: 'jingpin_web_zhongxue_v1.0.0',
      parent: 'jiazhang_web_zhongxue_v1.0.0',
      sound: 'yousheng_web_zhongxue_v1.0.0',
      special: 'zhuanti_web_gaozhong_v1.0.0',
      tb: 'tongbuke_web_gaozhong_v1.0.0',
    },
    // 一年级
    8: {
      home: 'tuijian_web_1nianji_v1.0.0',
      boutique: 'jingpin_web_1nianji_v1.0.0',
      parent: 'jiazhang_web_1nianji_v1.0.0',
      sound: 'yousheng_web_1nianji_v1.0.0',
      special: 'zhuanti_web_1nianji_v1.0.0',
      tb: 'tongbuke_web_1nianji_v1.0.0',
    },
    // 二年级
    9: {
      home: 'tuijian_web_2nianji_v1.0.0',
      boutique: 'jingpin_web_1nianji_v1.0.0',
      parent: 'jiazhang_web_1nianji_v1.0.0',
      sound: 'yousheng_web_1nianji_v1.0.0',
      special: 'zhuanti_web_2nianji_v1.0.0',
      tb: 'tongbuke_web_2nianji_v1.0.0',
    },
    // 三年级
    10: {
      home: 'tuijian_web_3nianji_v1.0.0',
      boutique: 'jingpin_web_3nianji_v1.0.0',
      parent: 'jiazhang_web_3nianji_v1.0.0',
      sound: 'yousheng_web_3nianji_v1.0.0',
      special: 'zhuanti_web_3nianji_v1.0.0',
      tb: 'tongbuke_web_3nianji_v1.0.0',
    },
    // 四年级
    11: {
      home: 'tuijian_web_4nianji_v1.0.0',
      boutique: 'jingpin_web_3nianji_v1.0.0',
      parent: 'jiazhang_web_3nianji_v1.0.0',
      sound: 'yousheng_web_3nianji_v1.0.0',
      special: 'zhuanti_web_4nianji_v1.0.0',
      tb: 'tongbuke_web_4nianji_v1.0.0',
    },
    // 五年级
    12: {
      home: 'tuijian_web_5nianji_v1.0.0',
      boutique: 'jingpin_web_3nianji_v1.0.0',
      parent: 'jiazhang_web_3nianji_v1.0.0',
      sound: 'yousheng_web_3nianji_v1.0.0',
      special: 'zhuanti_web_5nianji_v1.0.0',
      tb: 'tongbuke_web_5nianji_v1.0.0',
    },
    // 六年级
    13: {
      home: 'tuijian_web_6nianji_v1.0.0',
      boutique: 'jingpin_web_3nianji_v1.0.0',
      parent: 'jiazhang_web_3nianji_v1.0.0',
      sound: 'yousheng_web_3nianji_v1.0.0',
      special: 'zhuanti_web_6nianji_v1.0.0',
      tb: 'tongbuke_web_6nianji_v1.0.0',
    },
    // 奥数
    114: {
      home: 'tuijian_math', // 首页
      aoshu: 'aoshu_math', // 奥数
      caiyi: 'caiyi_math', // 才艺
      kexue: 'kexue_math', // 科学
      zhuanti: 'zhuanti_math', // 专题  
      sound: 'yousheng_web_1nianji_v1.0.0', // 有声频道
      parent: 'jiazhang_web_1nianji_v1.0.0', // 家长专区
      boutique: 'jingpin_web_1nianji_v1.0.0', // 精品专区
    },
    // 微课
    102: {
      home: 'tuijian_micro', // 首页
      weike: 'weike_micro', // 同步
      caiyi: 'caiyi_micro', // 才艺
      kexue: 'kexue_micro', // 科学百科
      zhuanti: 'zhuanti_micro', // 专题频道  
      sound: 'yousheng_web_1nianji_v1.0.0', // 有声频道
      parent: 'jiazhang_web_1nianji_v1.0.0', // 家长专区
      boutique: 'jingpin_web_1nianji_v1.0.0', // 精品专区
    },
    // 国学
    111: {
      home: 'tuijian_king', // 首页
      gouxue: 'guoxue_king', // 国学经典
      xingqu: 'xingqu_king', // 兴趣培养
      kepu: 'kepu_king', // 益智科普
      sound: 'yousheng_web_1nianji_v1.0.0', // 有声频道
      parent: 'jiazhang_web_1nianji_v1.0.0', // 家长专区
      boutique: 'jingpin_web_1nianji_v1.0.0', // 精品专区
    },
    // 故事
    112: {
      home: 'tuijian_story', // 首页
      gushi: 'gushi_story', // 故事
      caiyi: 'caiyi_story', // 才艺
      kexue: 'kexue_story', // 科学
      zhuanti: 'zhuanti_story', // 专题  
      sound: 'yousheng_web_1nianji_v1.0.0', // 有声频道
      parent: 'jiazhang_web_1nianji_v1.0.0', // 家长专区
      boutique: 'jingpin_web_1nianji_v1.0.0', // 精品专区
    }
  },

  // 帮助中心 参数 问题id
  helpId: '',
}
